@if (teamTypeConfiguration) {
    <div class="d-flex align-items-center gap-1">
        <span class="fa-layers team-icon flex-shrink-0">
            <i class="fas fa-fw fa-inverse"
               [style.background-color]="teamTypeConfiguration.iconColour"
               [ngClass]="teamTypeConfiguration.icon ?? 'fa-users'"
               aria-hidden="true"></i>
        </span>
        @if (showName) {
            {{ teamTypeConfiguration.name }}
        }
    </div>
}
